import React from "react";
import { useCurrentFrame } from "remotion";

export const EtherealBackground: React.FC = () => {
  const frame = useCurrentFrame();

  // Slow morphing animation
  const move1 = Math.sin(frame * 0.01) * 50;
  const move2 = Math.cos(frame * 0.015) * 40;
  const move3 = Math.sin(frame * 0.008 + 1) * 60;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#fafafa",
        overflow: "hidden",
        zIndex: 1,
      }}
    >
      {/* Texture Layer (Washi Paper effect) */}
      <svg width="100%" height="100%" style={{ opacity: 0.03, position: "absolute" }}>
        <filter id="noise">
          <feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" />
        </filter>
        <rect width="100%" height="100%" filter="url(#noise)" />
      </svg>

      {/* Morphing Prismatic Blobs */}
      <div
        style={{
          position: "absolute",
          top: "20%",
          left: "10%",
          width: "600px",
          height: "600px",
          background: "radial-gradient(circle, #ffc0cb 0%, transparent 70%)",
          filter: "blur(120px)",
          transform: `translate(${move1}px, ${move2}px) scale(1.2)`,
          opacity: 0.4,
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "10%",
          right: "5%",
          width: "700px",
          height: "700px",
          background: "radial-gradient(circle, #b388ff 0%, transparent 70%)",
          filter: "blur(140px)",
          transform: `translate(${move2}px, ${move3}px) scale(1.1)`,
          opacity: 0.3,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "40%",
          width: "500px",
          height: "500px",
          background: "radial-gradient(circle, #80deea 0%, transparent 70%)",
          filter: "blur(100px)",
          transform: `translate(${move3}px, ${move1}px)`,
          opacity: 0.35,
        }}
      />

      {/* Refractive Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 50%, rgba(255,255,255,0.1) 100%)",
          backdropFilter: "contrast(1.1) brightness(1.05)",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
